import { createApp } from "vue";

let vueObserver = null;

function initMutationObserver() {
    if (!vueObserver) {
        vueObserver = new MutationObserver((mutations) => {
            onMutations(mutations);
        });
        vueObserver.observe(document.body, { childList: true, subtree: true });
    }
}
initMutationObserver();

function onMutations(mutations) {
    for (const mutation of mutations) {
        for (let removedNode of mutation.removedNodes) {
            if (removedNode.nodeType === 1) {
                const componentToRemove = findVueComponent(removedNode);
                if (componentToRemove) {
                    if (componentToRemove.hasAttribute('data-state') && componentToRemove.getAttribute('data-state') === 'init_done') {
                        unmountVueComponent(componentToRemove);
                    }
                }
            }
        }

        for (const addedNode of mutation.addedNodes) {
            if (addedNode.nodeType === 1) {
                const componentToAdd = findVueComponent(addedNode);
                if(componentToAdd) {
                    if (componentToAdd.hasAttribute('data-state') && componentToAdd.getAttribute('data-state') === 'init') {
                        initializeVueComponent(componentToAdd);
                    }
                }
            }
        }
    }
}

function unmountVueComponent(node) {
    let vueParentInstance = node.__vueParentComponent;
    if (vueParentInstance) {
        if (vueParentInstance.appContext) {
            vueParentInstance.appContext.app.unmount();
            vueParentInstance.innerHTML = '';
            delete vueParentInstance.appContext.components;
        }
        else {
            vueParentInstance.unmount();
        }
        vueParentInstance = null;
        node.__vueParentComponent = null;
        delete node.__vueParentComponent;
    }
}

function initializeVueComponentsOnPageLoad() {
    const nodes = document.querySelectorAll('[data-component]');

    if (nodes.length > 0) {
        nodes.forEach((node) => {
            if (node.nodeType === 1) {
                initializeVueComponent(node);
            }
        });
    }
}
initializeVueComponentsOnPageLoad();

function findVueComponent(node) {
    if (node.hasAttribute('data-component')) return node;

    for (const child of node.children) {
        if (child.hasAttribute('data-component')) {
            return child;
        }
        const found = findVueComponent(child);
        if (found) return found;
    }
    return null
}

function registerComponentByName(app, component) {
    let basePath;

    try {
        switch (true) {
            case component.includes('Chart'):
                basePath = './components/charts/';
                break;
            case component.includes('Button'):
                basePath = './components/button/';
                break;
            default:
                basePath = './components/';
                break;
        }

        const c = require(`${basePath}${component}.vue`);
        let componentName = component.toLowerCase();
        app.component(componentName, c.default);
    } catch (error) {
        console.error(`Error while loading component ${component}:`, error);
    }
}

function initializeVueComponent(node) {
    let component = node.getAttribute('data-component');

    const container = node.parentElement.id;
    const mountPoint = document.querySelector(`#${container}`);

    if (mountPoint) {
        const instance = createApp({});
        registerComponentByName(instance, component);

        instance.directive('init-vue', {
            beforeMount: (el) => {
                el.setAttribute('data-state', 'init_done');
            }
        });

        instance.mount(mountPoint);
    }
}